export const GooglePayPreview = ({data}) => {
    return (
        <div
            className='googlepay-block-editor'
            style={{maxHeight: '40px', backgroundColor: '#000', borderRadius: '4px'}}>
            <img
                src={data.editorIcons.long}
                style={{width: '100%', height: '40px', objectFit: 'contain'}}/>
        </div>
    )
}

export default GooglePayPreview;